export default "__VITE_ASSET__DhMiRPem__"